type SentryConfig = {
  SentryDSN: string;
  SentryRelease: string;
};

export const sentryConfig: SentryConfig = {
  SentryDSN: import.meta.env.VITE_SENTRY_DSN,
  SentryRelease: import.meta.env.VITE_SENTRY_RELEASE,
};
